// extracted by mini-css-extract-plugin
export default {"h6Title":"CounselingDetails_h6Title__QGjFW","key":"CounselingDetails_key__ukSGp","value":"CounselingDetails_value__z4-ER"};